module.exports = __webpack_public_path__ + "img/icone_caixa_branco.14f10387.svg";